import { customActions } from './custom-actions';
import { createPageStore } from 'common/store';
import { INITIAL_STATE } from './constants';
export var useChatsListStore = createPageStore({
    initialValues: INITIAL_STATE,
    customActions: customActions,
});
